import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Pulse from 'react-reveal/Pulse'

import { Grid } from '@material-ui/core'
import { Card, SectionContainer, SectionTitle } from '../../_common'
import useStyles from './styles'

const getBlog = graphql`
  query {
    blog: allContentfulBlog {
      edges {
        node {
          id
          titulo
          slug
          autor
          fechaDeCreacion(formatString: "DD.MM.YY")
          imagen {
            fluid {
              ...GatsbyContentfulFluid
            }
          }
        }
      }
    }
  }
`

const BlogPosts = () => {
  const { bRoot } = useStyles()
  const response = useStaticQuery(getBlog)
  const blog = response.blog.edges

  return (
    <SectionContainer>
      <SectionTitle title="Blog actuarial" />

      <Grid container className={bRoot}>
        {blog.map(({ node }) => (
          <Pulse key={node.id}>
            <Card
              data={{
                titulo: node.titulo,
                slug: node.slug,
                fecha: node.fechaDeCreacion,
                info: node.autor,
                imagen: node.imagen,
                tipo: 'blog',
              }}
              textoBoton="leer más"
            />
          </Pulse>
        ))}
      </Grid>
    </SectionContainer>
  )
}

export default BlogPosts
